import { getCertificateByID } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetCertificateByID(id) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["certificates", `${id}`],
		fn: () => getCertificateByID(id),
	});

	const { certificate } = data || { certificate: [] };

	return { certificate, isPending, isSuccess, isError, error };
}
